import { CreditCard, CheckCircle2 } from "lucide-react";
import { money } from "../../lib/format";

export const BalanceCard = ({ balance, loading, period, onPay }) => {
  const debt = balance > 0;
  const label = loading ? "Hesaplanıyor" : debt ? "Güncel Borcunuz" : balance < 0 ? "Güncel Alacağınız" : "Borcunuz Yok";
  return (
    <div className={`relative overflow-hidden rounded-[2rem] p-8 sm:p-10 h-full text-white grain ${debt ? "bg-[#1B4332]" : "bg-[#2D6A4F]"}`} data-testid="balance-card">
      <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-[#D8F3DC]/10" aria-hidden="true" />
      <div className="relative z-10">
        <p className="eyebrow text-[#D8F3DC]">{label}</p>
        <p className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-3" data-testid="balance-amount">
          {loading ? "..." : money(Math.abs(balance))}
        </p>
        {period && (
          <p className="text-sm text-[#D8F3DC]/80 mt-3" data-testid="balance-period">
            {period.name} dönemi aylık aidat: {money(period.due_1)}{period.due_2 ? ` / ${period.due_2_date?.slice(0, 7)} sonrası ${money(period.due_2)}` : ""}
          </p>
        )}
        <div className="mt-8">
          {debt ? (
            <button onClick={onPay} data-testid="pay-debt-btn"
              className="inline-flex items-center gap-2 bg-[#E07A5F] hover:bg-[#c9664c] text-white font-bold px-7 py-4 rounded-full text-base transition-transform duration-200 hover:scale-[1.03]">
              <CreditCard size={20} /> Borcu Öde
            </button>
          ) : (
            !loading && <p className="inline-flex items-center gap-2 font-semibold text-[#D8F3DC]" data-testid="no-debt-msg"><CheckCircle2 size={20} /> Teşekkür ederiz, ödenecek borcunuz bulunmuyor.</p>
          )}
        </div>
      </div>
    </div>
  );
};
